/* cpg-shop-all-v2.js - the Shop All page's finder/facets/grid/sort logic. build: engine-gate-2026-08-22d
 * Externalized from sections/cpg-shop-all-v2.liquid (owner 2026-08-19) so its ~45KB
 * parse/compile runs deferred, off the main-thread critical path (was inline ~595ms
 * during HTML parse, gating FCP/LCP). Config comes from data-attributes on [data-cpg-sa2].
 */
(function () {
  var root = document.querySelector('[data-cpg-sa2]');
  if (!root) return;

  var API     = root.dataset.api;
  var CPG_LOGO = root.dataset.logo || '';
  var CAT_IMG = root.dataset.catImg || '';
  // Request a right-sized image from Shopify's CDN. Grid thumbs render in a ~96-148px
  // object-fit:contain box, so the source was 2048px for a 145px slot (~225 KiB each).
  // width=300 covers retina and is served identically by the fixed container. Only rewrites
  // Shopify file CDN urls (theme-asset .webp tiles don't take the transform param).
  function imgw(u, w) {
    if (!u || u.indexOf('/cdn/shop/') === -1 && u.indexOf('cdn.shopify.com') === -1) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  var CATURL = {}; try { var _cu = document.querySelector('[data-cpg-caturls]'); if (_cu) { var _mm = JSON.parse(_cu.textContent || '{}'); (_mm.mains || []).forEach(function (m) { if (m.slug && m.url) CATURL[m.slug] = m.url; if (m.name && m.url) CATURL[m.name] = m.url; (m.children || []).forEach(function (s) { if (s.slug && s.url) CATURL[s.slug] = s.url; if (s.name && s.url) CATURL[s.name] = s.url; (s.children || []).forEach(function (l) { if (l.slug && l.url) CATURL[l.slug] = l.url; if (l.name && l.url) CATURL[l.name] = l.url; }); }); }); } } catch (e) {}
  var SEARCH  = root.dataset.search || '/search';

  // EVERY LOOKUP IS SCOPED TO THE SECTION. The harness could use document.querySelector
  // because it was the only thing on the page. In a theme the header, the footer and the
  // announcement bar are all in the same document, and a document-level click handler on
  // [data-f] would fire on anything else that ever uses that attribute.
  var q = function (sel) { return root.querySelector(sel); };

  /* Loading-skeleton styles. Injected once here rather than in the section <style> because the
     markup they style (skeletonHTML) lives in THIS file — co-locating them keeps the two from
     drifting apart, and means the whole loading fix ships in one file. Scoped to .cpg-sa2 like
     every other rule for this section. The shimmer respects prefers-reduced-motion. */
  (function injectSkelCSS() {
    if (document.getElementById('cpg-sa2-skel-css')) return;
    var css =
      '.cpg-sa2 .cpg-skel{pointer-events:none;}' +
      '.cpg-sa2 .cpg-skel__box{display:block;background:#e7e9ee;border-radius:8px;position:relative;overflow:hidden;}' +
      '.cpg-sa2 .cpg-skel__box::after{content:"";position:absolute;inset:0;transform:translateX(-100%);' +
        'background:linear-gradient(90deg,transparent,rgba(255,255,255,.6),transparent);animation:cpgSkelSh 1.2s infinite;}' +
      '.cpg-sa2 .cpg-skel__photo{width:100%;aspect-ratio:1/1;border-radius:10px;}' +
      '.cpg-sa2 .cpg-skel__line{height:13px;margin:0 0 10px;}' +
      '.cpg-sa2 .cpg-skel__line--sm{width:38%;}' +
      '.cpg-sa2 .cpg-skel__line--md{width:70%;}' +
      '.cpg-sa2 .cpg-skel__line--lg{width:90%;height:17px;}' +
      '.cpg-sa2 .cpg-skel__chip{width:46%;height:26px;border-radius:13px;margin-top:6px;}' +
      '.cpg-sa2 .cpg-skel__btn{width:100%;height:42px;border-radius:9px;margin-top:10px;}' +
      /* skeletons are the loading state themselves — never dim them on top of the shimmer */
      '.cpg-sa2.is-loading .cpg-rows:has(.cpg-skel){opacity:1;}' +
      '@keyframes cpgSkelSh{100%{transform:translateX(100%);}}' +
      '@media (prefers-reduced-motion:reduce){.cpg-sa2 .cpg-skel__box::after{animation:none;}}';
    var el = document.createElement('style'); el.id = 'cpg-sa2-skel-css'; el.textContent = css;
    document.head.appendChild(el);
  })();

  var state = {
    main: '', vendors: '', stock: '', price: '', sort: 'relevance',
    page: 1, pageSize: 12, view: 'list',
    noFit: false, allCats: false, moreCats: false, moreVend: false,
    // Per-panel type-ahead. Filters the list already on screen; it does not query the API,
    // because the API returns every category and vendor for the current scope anyway.
    facetQ: { moreCats: '', moreVend: '' }
  };

  var fmt = function (n) { return (n || 0).toLocaleString('en-US'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g,
    function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var ico = function (id, c) { return '<svg class="ico ' + (c || '') + '"><use href="#i-' + id + '"/></svg>'; };
  var slug = function (s) {
    return s.toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };
  function money(v) {
    var n = parseFloat(v); if (!isFinite(n)) return '';
    var p = n.toFixed(2).split('.');
    return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '<small>.' + p[1] + '</small>';
  }

  /* ── THE GARAGE ────────────────────────────────────────────────────────────────────
     The reason this section exists at all. Our own copy on the vehicle page reads "Save
     it and every other page filters too" — and until now Shop All never read the key, so
     Suspension & Steering said 10,815 to someone who had told us they drive a Sierra, for
     which the true answer is 224.

     Precedence: an explicit ?make=&model= in the URL beats the garage, because that is a
     shopper following a specific link and it must not be overridden by whatever they saved
     last week. Then the garage. `noFit` is the shopper turning it off for this visit; it
     does NOT clear the garage, which is theirs and not ours to delete.

     Make and model are enough. The vehicle page's own save card offers "Any year", so
     requiring a year here would ignore exactly the vehicles we ourselves write. */
  var KEY = 'cpg:garage:vehicle';
  function garage() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  var URL_VEH = (function () {
    var u = new URLSearchParams(location.search);
    var mk = u.get('make'), md = u.get('model');
    if (!mk || !md) return null;
    var y = parseInt(u.get('year') || '', 10);
    return { year: y || null, make: mk, model: md, submodel: u.get('submodel') || null, engine: u.get('engine') || null, from: 'url' };
  })();
  function veh() {
    if (state.noFit) return null;
    if (URL_VEH) return URL_VEH;
    var g = garage();
    if (!g || !g.make || !g.model) return null;
    return { year: g.year || null, make: g.make, model: g.model, submodel: g.submodel || null, engine: g.engine || null, from: 'garage' };
  }
  function vehLabel(v) {
    return [v.year, v.make, v.model, v.submodel, v.engine].filter(Boolean).join(' '); // full vehicle incl. engine (owner 2026-10-02)
  }
  // Per-part fit state (numeric product id -> FitState) from /fit/bulk for the visible page. Lets an
  // engine-qualified part wait for the engine (NEEDS_QUALIFIER) instead of showing a buyable "Fits",
  // exactly like the PDP and the category/collection cards.
  var fitMap = {};
  function fetchFitBulk(d, signal) {
    var v = veh();
    var pids = (d.products || []).map(function (p) { return p.id; }).filter(Boolean).slice(0, 250);
    var body = JSON.stringify({
      v: { year: v.year, make: v.make, model: v.model, submodel: v.submodel || undefined, engine: v.engine || undefined },
      pids: pids
    });
    return fetch(API + '/storefront/fitment/fit/bulk', { method: 'POST', headers: { 'content-type': 'text/plain' }, body: body, signal: signal })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (res) { var m = {}, rr = (res && res.results) || {}; Object.keys(rr).forEach(function (k) { m[k] = rr[k] && rr[k].state; }); return m; })
      .catch(function () { return {}; });   // bulk failure -> card falls back to the catalog fit_class
  }

  // Skeleton placeholders painted into an EMPTY grid while the (cold, sometimes multi-second)
  // catalog fetch is in flight, so the reader sees the shape of the results forming instead of
  // an empty dimmed box that can read as "nothing here" or "frozen". Only used when the grid has
  // no real rows yet (first load, or after an error); a filter/sort re-fetch keeps its existing
  // rows and just dims them (the .is-loading opacity), which is the better feedback there.
  function skeletonHTML(n) {
    var one = '<div class="cpg-row cpg-skel" aria-hidden="true">' +
      '<div class="cpg-row__media"><span class="cpg-skel__box cpg-skel__photo"></span></div>' +
      '<div class="cpg-row__body">' +
        '<span class="cpg-skel__box cpg-skel__line cpg-skel__line--sm"></span>' +
        '<span class="cpg-skel__box cpg-skel__line cpg-skel__line--lg"></span>' +
        '<span class="cpg-skel__box cpg-skel__line cpg-skel__line--md"></span>' +
        '<span class="cpg-skel__box cpg-skel__chip"></span>' +
      '</div>' +
      '<div class="cpg-row__buy">' +
        '<span class="cpg-skel__box cpg-skel__line cpg-skel__line--sm"></span>' +
        '<span class="cpg-skel__box cpg-skel__btn"></span>' +
      '</div>' +
    '</div>';
    var out = ''; for (var i = 0; i < n; i++) out += one; return out;
  }
  function gridHasRealRows() {
    var rows = q('[data-rows]');
    return !!(rows && rows.querySelector('.cpg-row:not(.cpg-skel)'));
  }

  var loadSeq = 0;
  var GRID_TIMEOUT_MS = 20000;   // a fetch still unanswered after this is treated as failed, not "still coming"
  function load() {
    // Sequence every fetch so a slower in-flight response (e.g. the with-vehicle request that
    // was still loading when the shopper hit Remove) can never render on top of a newer one and
    // leave the page showing stale fitment badges/door.
    var seq = ++loadSeq;
    root.classList.add('is-loading');   // immediate "updating" feedback (dims the grid) — the fetch can be cold/slow
    // Empty grid (first load / post-error) → paint skeletons so it never sits blank+dimmed forever.
    if (!gridHasRealRows()) { var _rows = q('[data-rows]'); if (_rows) _rows.innerHTML = skeletonHTML(12); }
    // Abort a fetch that never answers so the grid can show a real error+retry instead of dimming
    // forever. AbortController is universally available in the theme's supported browsers; guard
    // anyway so an absent implementation simply skips the timeout rather than throwing.
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timedOut = false;
    var timer = setTimeout(function () { timedOut = true; if (ctrl) ctrl.abort(); }, GRID_TIMEOUT_MS);
    var signal = ctrl ? ctrl.signal : undefined;
    var p = new URLSearchParams({ page_size: String(state.pageSize), page: String(state.page) });
    var v = veh();
    if (v) {
      if (v.year) p.set('year', v.year);
      p.set('make', v.make); p.set('model', v.model);
      if (v.submodel) p.set('submodel', v.submodel);
      if (v.engine) p.set('engine', v.engine);
    }
    if (state.main) p.set('main', state.main);
    if (state.vendors) p.set('vendors', state.vendors);
    if (state.stock) p.set('stock', state.stock);
    if (state.price && PRICE_BUCKETS[state.price]) {
      var pb = PRICE_BUCKETS[state.price];
      if (pb.min != null) p.set('price_min', pb.min);
      if (pb.max != null) p.set('price_max', pb.max);
    }
    if (state.sort !== 'relevance') p.set('sort', state.sort);
    var url = API + '/storefront/catalog/products?' + p.toString();
    // Reuse the EARLY-FIRE prefetch (kicked off by an inline <script> during HTML parse, before this
    // ~45KB bundle even downloaded) when it matches this exact first-load URL — cutting the ~2s of
    // JS-boot latency the grid fetch used to sit behind. The prefetch promise already resolves to
    // parsed JSON; the normal path parses the Response here. A miss just falls back to a fresh fetch.
    var pf = window.__cpgSA2Prefetch, jsonP;
    if (pf && !pf.used && pf.url === url) { pf.used = true; jsonP = pf.p; }
    else { jsonP = fetch(url, { signal: signal }).then(function (r) { return r.ok ? r.json() : Promise.reject(); }); }
    jsonP
      .then(function (d) {
        if (seq !== loadSeq) return;
        var fv = veh();
        // PAINT NOW: render the product cards AND the category grid immediately from the catalog
        // response (its fit_class), so nothing waits on the second round-trip. THEN upgrade the
        // per-part fitment badges in place when /fit/bulk resolves — an engine-qualified part shows
        // the catalog "Fits" for a beat, then refines to "Select your engine to confirm fit". This
        // removes ~0.8s of blank grid vs. the old "wait for /fit/bulk before the first paint".
        fitMap = {};
        render(d);
        if (fv && fv.year && d.products && d.products.length) {
          fetchFitBulk(d, signal).then(function (m) { if (seq !== loadSeq) return; fitMap = m; render(d); });
        }
      })
      .catch(function () {
        if (seq !== loadSeq) return;
        // Silence beats a zero. "0 parts" reads as "we stock nothing". A dead/slow fetch (network
        // error or the 20s timeout above) lands here — give the reader an explicit Retry that
        // re-runs load(), so a cold/hung request is recoverable in place instead of dimming forever.
        var rows = q('[data-rows]');
        if (rows) rows.innerHTML = '<div class="cpg-empty">' +
          '<p>We could not load parts just now' + (timedOut ? ' (the request timed out)' : '') + '. ' +
          'Check your connection, or try again.</p>' +
          '<button type="button" class="cpg-row__addcart cpg-sa-retry" data-sa-retry style="width:auto;margin-top:12px;">' +
          ico('return', 'ico--s') + 'Try again</button></div>';
      })
      .then(function () { clearTimeout(timer); if (seq === loadSeq) root.classList.remove('is-loading'); });   // clear the dim + timer (runs after success OR error)
  }

  var lastData = null;
  // Cache the last-written HTML of the blocks that DON'T change on sort/page/view, so we skip the
  // costly innerHTML rewrite (HTML reparse + reflow + tile-image refetch) when they're identical.
  var _shelfHTML = null, _facetHTML = null, _chipsHTML = null;
  function render(d) {
    lastData = d;
    // Wiper Blades is hidden from nav/grid site-wide (NAV_EXCLUDE), so keep it off the shelf too.
    var f = d.facets || {}, cats = (f.main_categories || []).filter(function (c) { return slug(c.value) !== 'wiper-blades'; }), vend = f.vendors || [];
    var all = f.all || d.total;
    var v = veh();

    renderVehicleBar(v, d.total);

    q('[data-h1]').textContent = v
      ? fmt(d.total) + ' parts fit your ' + vehLabel(v) // real fits only (Option A)
      : fmt(all) + ' parts. Let us narrow it.';
    q('[data-catdesc]').textContent = cats.length + ' categories, three levels deep. Best when you know the job.';
    q('[data-catcount]').textContent = cats.length + ' categories';
    q('[data-branddesc]').textContent = vend.slice(0, 3).map(function (x) { return x.vendor; }).join(', ')
      + (vend.length > 3 ? ' and ' + (vend.length - 3) + ' more you already trust.' : '');
    q('[data-brandcount]').textContent = vend.length + ' brands';
    var allBtn = q('[data-allcats]');
    allBtn.textContent = state.allCats ? 'Show fewer' : 'Show all ' + cats.length + ' categories';
    // Mobile shows only the first 4 tiles (rest hidden by CSS); desktop shows 10. So the "show
    // all" toggle must appear whenever there are more categories than are VISIBLE — not only when
    // >10 — otherwise a phone with 5-10 categories is stuck at four tiles with no way to the rest.
    allBtn.hidden = cats.length <= (window.matchMedia('(max-width: 767px)').matches ? 4 : 10);

    var shelfHTML = (state.allCats ? cats : cats.slice(0, 10)).map(function (c, i) {
      // cpg-tile--rest hides everything past the fourth tile on a phone, so that the shelf
      // cannot push the results below the fold. Once the shopper has asked for all of them,
      // that is no longer our call to make.
      // When a brand is selected, carry it onto the tile so clicking the MAIN category drills into that
      // brand's sub-categories (e.g. Power Stop -> Brakes -> Pads/Rotors/Calipers), matching the brand
      // collection, instead of dropping the brand and jumping to the all-brands category page.
      return '<a class="cpg-tile' + (i >= 4 && !state.allCats ? ' cpg-tile--rest' : '') +
        '" href="' + (CATURL[c.value] || ('/collections/' + encodeURIComponent(c.value))) + (state.vendors ? '#brand=' + encodeURIComponent(state.vendors) : '') + '">' +
        '<span class="cpg-tile__photo">' +
          (CAT_IMG ? '<img src="' + CAT_IMG + esc(slug(c.value)) + '.webp" alt="" decoding="async" '
            + (i < 5 ? 'loading="eager"' + (i === 0 ? ' fetchpriority="high"' : '') : 'loading="lazy"')
            + ' onerror="this.remove()">' : '') +
        '</span>' +
        '<span class="cpg-tile__b"><span class="cpg-tile__n">' + esc(c.value) + '</span>' +
        '<span class="cpg-tile__c">' + fmt(c.count) + ' parts</span></span></a>';
    }).join('');
    if (shelfHTML !== _shelfHTML) { _shelfHTML = shelfHTML; q('[data-shelf]').innerHTML = shelfHTML; }
    // The shelf reserves min-height:360px for the full 10-tile / 2-row layout. When a brand filter
    // narrows it to one or two categories, that reserve makes the lone tile stretch to 360px tall (huge
    // empty band). Collapse to content-height and stop the tiles stretching whenever the row isn't full.
    var _shelfGrid = q('[data-shelf]'), _nTiles = (state.allCats ? cats : cats.slice(0, 10)).length;
    if (_shelfGrid) { var _few = _nTiles > 0 && _nTiles <= 4; _shelfGrid.style.minHeight = _few ? '0px' : ''; _shelfGrid.style.alignItems = _few ? 'start' : ''; }

    // SHOW MORE ACTUALLY SHOWS MORE. The rail caps Category at 6 and Brand at 5, so with
    // 15 categories and 27 brands most of the filters were unreachable behind a button
    // that was rendered and never wired.
    var match = function (list, key, field) {
      var needle = (state.facetQ[key] || '').trim().toLowerCase();
      if (!needle) return list;
      return list.filter(function (x) { return String(x[field] || '').toLowerCase().indexOf(needle) >= 0; });
    };
    cats = match(cats, 'moreCats', 'value');
    vend = match(vend, 'moreVend', 'vendor');
    // A search that matched something should show what it matched, not the first six of it.
    var catN = (state.moreCats || state.facetQ.moreCats) ? cats.length : 6;
    var venN = (state.moreVend || state.facetQ.moreVend) ? vend.length : 5;
    var facetHTML =
      panel('sell', 'Brand', true, vend.slice(0, venN).map(function (x) {
        return frow(x.vendor, x.count, 'vendors', x.vendor, state.vendors === x.vendor); }).join(''),
        vend.length > 5 ? (state.moreVend ? 'Show fewer' : 'Show all ' + vend.length + ' brands') : '',
        'moreVend') +
      pricePanel(f) +
      panel('box', 'Availability', false,
        frow('In stock, ships today', f.in_stock, 'stock', 'in', state.stock === 'in') +
        frow('Backorder', Math.max(0, all - f.in_stock), 'stock', 'backorder', state.stock === 'backorder'), '');
    if (facetHTML !== _facetHTML) { _facetHTML = facetHTML; q('[data-facets]').innerHTML = facetHTML; }

    q('[data-count]').innerHTML = '<strong>' + fmt(d.total) + '</strong> parts' +
      (d.total !== all ? ', filtered from <strong>' + fmt(all) + '</strong>' : '');

    // THE NOTE HAS TO AGREE WITH THE ROWS. Left as written, it says "we do not know your
    // vehicle yet" on a page that has just filtered itself to that vehicle.
    var note = q('[data-note]');
    if (note) {
      note.classList.toggle('cpg-note--fit', !!v); // green confirmation only when a vehicle is set
      note.innerHTML = v
        ? ico('check') + '<span><strong>Every row below fits your ' + esc(vehLabel(v)) + '.</strong> ' +
          'Anything that does not has already dropped out, and the counts in the rail are fit counts.</span>'
        : ico('help') + '<span><strong>No row below says whether it fits</strong>, because we do not know ' +
          'your vehicle yet. Each one offers to check instead. Add a vehicle and every row gains a real ' +
          'answer, the counts in the rail become fit counts, and anything that does not fit drops out.</span>';
    }

    var chips = [];
    if (v) chips.push(['fit', vehLabel(v)]);
    if (state.main) chips.push(['main', state.main]);
    if (state.vendors) chips.push(['vendors', state.vendors]);
    if (state.price && PRICE_BUCKETS[state.price]) chips.push(['price', PRICE_BUCKETS[state.price].label]);
    if (state.stock) chips.push(['stock', state.stock === 'in' ? 'In stock' : 'Backorder']);
    var chipsHTML = chips.map(function (c) {
      return '<a class="cpg-chip" href="#" data-un="' + c[0] + '">' + esc(c[1]) + ico('close', 'ico--s') + '</a>';
    }).join('');
    if (chipsHTML !== _chipsHTML) { _chipsHTML = chipsHTML; q('[data-chips]').innerHTML = chipsHTML; }
    q('[data-clear]').hidden = chips.length === 0;
    [q('[data-dockcount]'), q('[data-toolbarcount]')].forEach(function (badge) {
      if (!badge) return;
      badge.hidden = chips.length === 0;
      badge.textContent = chips.length;
    });

    var rowsEl = q('[data-rows]');
    rowsEl.classList.toggle('cpg-rows--grid', state.view === 'grid');
    rowsEl.innerHTML = (d.products || []).length
      ? d.products.map(function (p) { return row(p, v); }).join('')
      : '<div class="cpg-empty">Nothing matches those filters. Remove one above to widen the search.</div>';

    renderPager(d);
    syncSheet();   // keep the mobile sheet's Sort/Per-page highlight + result count current
  }

  /* THE PAGER. Without it this page showed 24 of 42,318 products and stopped: no shopper
     could ever reach the 25th. Page numbers are a WINDOW around the current page, not all
     1,763 of them — and the window is what makes the count honest, because "Page 1 of
     1,763" tells the reader how deep the catalogue is while the filters stay one click
     away in the rail. */
  var MAX_PAGES = 500;
  function renderPager(d) {
    var el = q('[data-pager]'); if (!el) return;
    var size = d.page_size || state.pageSize;
    // The catalog API serves pages 1..500 only (deep pages are costly and mostly scraper traffic);
    // anything past that returned page 500 again. Stop the bar there and say so.
    var realPages = Math.max(1, Math.ceil((d.total || 0) / size));
    var pages = Math.min(realPages, MAX_PAGES);
    if (pages <= 1) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;

    var cur = Math.min(state.page, pages);
    var from = Math.max(1, cur - 2), to = Math.min(pages, from + 4);
    from = Math.max(1, Math.min(from, to - 4));

    var html = '<button type="button" class="cpg-pager__step" data-page="' + (cur - 1) + '"' +
               (cur <= 1 ? ' disabled' : '') + '>Previous</button>';
    if (from > 1) {
      html += num(1, cur) + (from > 2 ? '<span class="cpg-pager__gap">&hellip;</span>' : '');
    }
    for (var i = from; i <= to; i++) html += num(i, cur);
    if (to < pages) {
      html += (to < pages - 1 ? '<span class="cpg-pager__gap">&hellip;</span>' : '') + num(pages, cur);
    }
    html += '<button type="button" class="cpg-pager__step" data-page="' + (cur + 1) + '"' +
            (cur >= pages ? ' disabled' : '') + '>Next</button>' +
            '<span class="cpg-pager__at">Page ' + fmt(cur) + ' of ' + fmt(pages) +
            (realPages > pages ? '. Showing the first ' + fmt(pages * size) + ' of ' + fmt(d.total) + ' parts. Use the filters or search to narrow down.' : '') + '</span>';
    el.innerHTML = html;
  }
  function num(n, cur) {
    return '<button type="button" class="cpg-pager__n' + (n === cur ? ' is-on' : '') + '"' +
           ' data-page="' + n + '"' + (n === cur ? ' aria-current="page"' : '') + '>' + fmt(n) + '</button>';
  }

  /* THE THEME ALREADY HAS A VEHICLE BAR, AND TWO IS WORSE THAN EITHER.
     Rendered inside the real chrome, this section's bar landed directly under the site's
     own one, so the page opened with "No vehicle selected, showing all 43,541 parts"
     stacked on "No vehicle saved" — the same sentence twice, with two different totals
     from two different sources. The site bar wins: it is sitewide, it owns the picker, and
     it is what the shopper sees on every other page. Ours only appears when there is no
     site bar to defer to, which is how the local harness runs.

     The one thing our bar carried that the site bar does not is "Show all parts". That
     lives on the vehicle chip in the toolbar, whose x removes the fit filter, so nothing
     is lost by standing down. */
  function renderVehicleBar(v, total) {
    // Fold the big "Narrow results to your vehicle" finder once a vehicle is set — the
    // sitewide vehicle bar and the Applied chip already show it, so the YMM box is redundant.
    var hf = q('.cpg-hfinder'); if (hf) hf.classList.toggle('is-folded', !!v);

    // The primary "By vehicle" door becomes the "YOUR {model}" confirmation once a vehicle
    // is set: green tick tile, the vehicle, how many parts fit, and a Switch-vehicle action.
    var vdoor = q('[data-sa-door-vehicle]');
    if (vdoor) {
      if (vdoor.dataset.origHtml == null) vdoor.dataset.origHtml = vdoor.innerHTML;
      vdoor.classList.toggle('is-set', !!v);
      if (v) {
        var mShort = (v.model || 'vehicle').split(' ')[0];
        var vl = vehLabel(v);
        var full = esc(vl) + (v.submodel && vl.indexOf(v.submodel) < 0 ? ', ' + esc(v.submodel) : '');
        vdoor.innerHTML =
          '<span class="cpg-door__tile cpg-door__tile--fit"><svg class="ico ico--l"><use href="#i-check"/></svg></span>' +
          '<span class="cpg-door__body">' +
            '<span class="cpg-door__t">Your ' + esc(mShort) + '</span>' +
            '<span class="cpg-door__d">' + full + '. Every page on the site is filtered to it.</span>' +
          '</span>' +
          '<span class="cpg-door__m cpg-door__m--fit">' + fmt(total) + ' parts fit</span>' +
          '<span class="cpg-door__go"><span>Switch vehicle</span> <svg class="ico ico--s"><use href="#i-arrow"/></svg></span>';
      } else if (vdoor.dataset.origHtml != null) {
        vdoor.innerHTML = vdoor.dataset.origHtml;
      }
    }

  }

  function panel(icon, title, search, inner, more, moreKey) {
    return '<div class="cpg-facet"><div class="cpg-facet__head">' + ico(icon) +
      '<span class="cpg-facet__title">' + esc(title) + '</span></div>' +
      // A box that says "Search…" and cannot be typed into is worse than no box: it
      // invites the fastest way to find a brand among 27 and then refuses it.
      (search ? '<label class="cpg-facet__search">' + ico('search', 'ico--s') +
        '<input type="search" class="cpg-facet__searchinput" placeholder="Search ' +
        esc(title.toLowerCase()) + '" data-sa-facetsearch="' + esc(moreKey || '') + '"' +
        ' value="' + esc(state.facetQ[moreKey] || '') + '"></label>' : '') +
      '<div class="cpg-facet__list">' + inner + '</div>' +
      (more ? '<button type="button" class="cpg-facet__more" data-sa-more="' + esc(moreKey) + '">' +
        esc(more) + '</button>' : '') +
      '</div>';
  }

  /* PRICE WAS FIVE STATIC DIVS. They carried real counts from the API and did nothing when
     clicked, which is the worst of both: it looks answered and filters nothing. The browse
     endpoint takes price_min / price_max, so each bucket maps onto a real query. */
  var PRICE_BUCKETS = {
    under_100:  { label: 'Under $100',       min: null, max: 100 },
    '100_250':  { label: '$100 to $250',     min: 100,  max: 250 },
    '250_500':  { label: '$250 to $500',     min: 250,  max: 500 },
    '500_1000': { label: '$500 to $1,000',   min: 500,  max: 1000 },
    over_1000:  { label: 'Over $1,000',      min: 1000, max: null }
  };
  function pricePanel(f) {
    var b = f.price_buckets || [];
    return '<div class="cpg-facet"><div class="cpg-facet__head">' + ico('pay') +
      '<span class="cpg-facet__title">Price</span></div><div class="cpg-facet__list">' +
      b.map(function (x) {
        var def = PRICE_BUCKETS[x.key];
        if (!def) return '';
        return frow(def.label, x.count, 'price', x.key, state.price === x.key);
      }).join('') +
      '</div></div>';
  }
  function frow(label, count, key, val, on) {
    return '<a class="cpg-facet__row" href="#" data-f="' + key + '" data-v="' + esc(val) + '"' +
      ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
      '<span class="cpg-facet__box">' + (on ? ico('check', 'ico--s') : '') + '</span>' +
      '<span class="cpg-facet__label">' + esc(label) + '</span>' +
      '<span class="cpg-facet__count">' + fmt(count) + '</span></a>';
  }

  /* NO FIT CLAIM WITHOUT A VEHICLE, AND NO ADD TO CART EITHER WAY.
     With no vehicle: amber check-fit chip and a locked panel. With one: the API's vehicle
     scope joins product_vehicles on make and model, so every row it returned has a fitment
     record for that vehicle and the green chip is a fact rather than a guess. The buy
     button still does not appear here — this section owns no cart flow, and the product
     page is where the variant, the quantity and the ask-us fork live. */
  function row(p, v) {
    var stock = p.in_stock
      ? '<span class="cpg-row__stock"><span class="cpg-dot"></span>' + ico('check', 'ico--s') + 'In stock, ships today</span>'
      : '<span class="cpg-row__stock is-backorder"><span class="cpg-dot"></span>' + ico('help', 'ico--s') + 'Backorder</span>';
    // Fit gate — per-part state from /fit/bulk (fitMap) so an engine-qualified part waits for the
    // engine instead of a buyable "Fits" (matches the PDP + collection cards). Universal/build-spec
    // stay buyable; NEEDS_QUALIFIER -> locked "select your engine"; UNKNOWN -> verify manually.
    var numId = String(p.id || '').replace(/^.*\//, '');
    var st = fitMap[numId];
    var isUni = p.fit_class === 'universal' || p.fit_class === 'build_spec' || st === 'UNIVERSAL' || st === 'BUILD_SPEC';
    var buyable, lockMsg = '', fitChip;
    if (!v) {
      buyable = false; lockMsg = 'Select your vehicle to check fit';
      fitChip = '<span class="cpg-chip--checkfit">' + ico('help', 'ico--s') + 'Add vehicle to check fit</span>';
    } else if (isUni) {
      buyable = true;
      fitChip = '<span class="cpg-chip--fits" style="background:#e8f0fe;color:#1a56db;border-color:#bcd0f7;">' + ((p.fit_class === 'build_spec' || st === 'BUILD_SPEC') ? 'Sold by Spec' : 'Universal Fitment') + '</span>';
    } else if (st === 'NO_FIT') {
      return '';   // grid is pre-filtered to fits+universal; guard against a stray non-fitting card
    } else if (st === 'NEEDS_QUALIFIER') {
      buyable = false; lockMsg = 'Select your engine to confirm fit';
      fitChip = '<span class="cpg-chip--fits" style="background:#fff8e6;color:#8a6100;border-color:#f2e0b0;">' + ico('help', 'ico--s') + 'Select your engine to confirm fit</span>';
    } else if (st === 'UNKNOWN') {
      buyable = false; lockMsg = 'Verify fitment manually';
      fitChip = '<span class="cpg-chip--checkfit">' + ico('help', 'ico--s') + 'Verify fitment manually</span>';
    } else {
      buyable = true;
      fitChip = '<span class="cpg-chip--fits">' + ico('check', 'ico--s') + 'Fits your ' + esc(vehLabel(v)) + '</span>';
    }
    /* THE TITLE AND THE PHOTO ARE LINKS. They were not, and that made the page look broken:
       the ONLY route to a product was the small "Full details & fitment" button, which on a
       phone is a 46px arrow icon. Everyone clicks the picture or the name of the thing they
       want. Nothing happened, on all 24 rows. */
    buyable = true; // MOCKUP 2026-10-02 (owner): never block
    var href = '/products/' + esc(p.handle);
    return '<div class="cpg-row">' +
      '<div class="cpg-row__media">' +
        '<a class="cpg-row__photo' + (p.image ? '' : ' cpg-row__photo--ph') + '" href="' + href + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(imgw(p.image, 300)) + '" width="300" height="300" alt="" loading="lazy" decoding="async">' : '<img class="cpg-row__logoph" src="' + CPG_LOGO + '" width="150" height="150" alt="' + esc(p.title) + '" loading="lazy" decoding="async">') + '</a>' +
        (p.images_count > 1 ? '<span class="cpg-row__more">+' + (p.images_count - 1) + ' photos</span>' : '') +
      '</div>' +
      '<div class="cpg-row__body">' +
        '<div class="cpg-row__ids">' +
          '<span class="cpg-row__brand">' + esc(p.vendor || '') + '</span>' +
          (p.sku ? '<span class="cpg-row__sku"><span class="cpg-row__skulabel">SKU </span>' + esc(p.sku) + '</span>' : '') +
        '</div>' +
        // The photo above carries aria-hidden and tabindex -1 so a screen reader and the tab
        // order meet ONE link per row, not two pointing at the same product. This is that link.
        '<h3 class="cpg-row__title"><a href="' + href + '">' + esc(p.title) + '</a></h3>' +
        /* WARRANTY IS WIRED (2026-08-18). It is now the REAL per-product term from the
           pushed custom.warranty metafield (sourced SEMA/ASAP, ~19.9k live products),
           carried on the projection and returned as p.warranty by
           /storefront/catalog/products. Rendered in the actions row below ONLY when the
           product actually has a value — never a hardcoded store-wide claim. */
        '<div class="cpg-row__meta">' + stock + '</div>' +
        (p.snippet ? '<p class="cpg-row__desc">' + esc(p.snippet) + '</p>' : '') +
        '<div class="cpg-row__chips">' + fitChip +
          (p.main_category ? '<span class="cpg-chip--attr">' + esc(p.main_category) + '</span>' : '') +
          (p.sub_category ? '<span class="cpg-chip--attr">' + esc(p.sub_category) + '</span>' : '') +
        '</div>' +
        /* 90-day returns stays: it is a STORE policy, true of every product, and the
           announcement bar states it site-wide. That is the test each of these lines has
           to pass — sourced from the product, or true of the whole store. */
        '<div class="cpg-row__actions">' +
          (p.warranty ? '<span class="cpg-row__warranty">' + ico('shield', 'ico--s') + esc(p.warranty) + '</span>' : '') +
          '<span class="cpg-row__returns">' + ico('return', 'ico--s') + '60-day returns</span>' +
        '</div>' +
      '</div>' +
      '<div class="cpg-row__buy">' +
        /* FREE SHIPPING, CARRYING ITS CONDITION. Owner asked for it back, so it is back.
           It is written the way the announcement bar writes it rather than as a bare
           "Free shipping", because the policy is orders up to 50 lbs within the USA and
           shipping weight is not in the projection — so a bare claim under a $1,449 shock
           kit is one we might not be able to keep. Same line on every row, which makes it
           a statement of store policy rather than a promise about this part. */
        '<div class="cpg-row__prices">' +
          '<span class="cpg-row__price">' + money(p.price) + '</span>' +
          '<span class="cpg-row__ship">Free shipping over $80</span>' +
        '</div>' +
        '<div class="cpg-row__cta">' +
          (buyable
            ? '<button type="button" class="cpg-row__addcart" data-add="' + esc(p.variant_id || '') + '">' + ico('cart', 'ico--s') + 'Add to cart</button>'
            : '<span class="cpg-row__locked">' + ico('lock', 'ico--s') + '<span>' + esc(lockMsg || 'Select your vehicle to check fit') + '</span></span>') +
          '<a class="cpg-row__details" aria-label="' + esc(p.title) + ' — full details and fitment" href="/products/' + esc(p.handle) + '">' +
            '<span>Full details &amp; fitment</span>' + ico('arrow', 'ico--s') + '</a>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // Refresh the top-bar cart count AND total from the live cart. The theme's own fetch
  // patch refreshes the count but leaves the mini-total ($) stale, so we set both from truth.
  function cpgRefreshHeaderCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var tot = '$' + (c.total_price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // ONLY the leaf count badges — .cpg-tb-m__cart / .cpg-tb__cart-ic hold the SVG icon,
      // so writing textContent there wipes the icon (mobile cart looked broken).
      document.querySelectorAll('.cpg-tb__cart-n, .cpg-tb-m__badge').forEach(function (el) { el.textContent = c.item_count; });
      document.querySelectorAll('.cpg-tb__cart-total').forEach(function (el) { el.textContent = tot; });
    }).catch(function () {});
  }

  // AJAX add-to-cart, identical to the category card. We open the theme cart drawer and
  // refresh the header ourselves, so the cart shows up and the count+total both update.
  function addToCart(btn) {
    var id = btn.getAttribute('data-add');
    if (!id || btn.disabled) return;
    if (btn.dataset.orig == null) btn.dataset.orig = btn.innerHTML; // pristine label, even mid-"Added"
    var old = btn.dataset.orig;
    btn.disabled = true; btn.innerHTML = ico('cart', 'ico--s') + 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        // Open the theme cart drawer (it re-renders from the live cart, so the item list +
        // subtotal are current). This is what makes the cart "show up" on add.
        if (window.cpgOpenCart) { try { window.cpgOpenCart(); } catch (e) {} }
        cpgRefreshHeaderCart(); // the theme patch updates the count but NOT the mini-total
        btn.disabled = false; // re-enable NOW so re-adding the same item doesn't need a second click
        btn.innerHTML = ico('check', 'ico--s') + 'Added';
        setTimeout(function () { if (btn.innerHTML.indexOf('Added') !== -1) btn.innerHTML = old; }, 1600);
      })
      .catch(function () { btn.innerHTML = old; btn.disabled = false; });
  }

  // ── interaction. Scoped to the section, never to the document. ─────────────────────
  root.addEventListener('click', function (e) {
    var addcart = e.target.closest('[data-add]');
    if (addcart) { e.preventDefault(); addToCart(addcart); return; }
    var retry = e.target.closest('[data-sa-retry]');
    if (retry) { e.preventDefault(); load(); return; }   // re-run the grid fetch after a load error/timeout
    var f    = e.target.closest('[data-f]'),
        un   = e.target.closest('[data-un]'),
        cat  = e.target.closest('[data-cat]'),
        cl   = e.target.closest('[data-clear]'),
        more = e.target.closest('[data-allcats]'),
        fmore = e.target.closest('[data-sa-more]'),
        pg   = e.target.closest('[data-page]'),
        vw   = e.target.closest('[data-view]'),
        door = e.target.closest('[data-sa-door-vehicle]');

    if (pg && !pg.disabled) {
      e.preventDefault();
      state.page = Math.max(1, parseInt(pg.dataset.page, 10) || 1);
      load();
      // Page 3 of a list you are half way down is disorienting; put the reader at the top
      // of the results, not the top of the document, so the filters stay in view.
      var top = q('[data-rows]');
      if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (vw) {
      e.preventDefault();
      state.view = vw.dataset.view;
      root.querySelectorAll('[data-view]').forEach(function (b) {
        var on = b === vw;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (lastData) render(lastData);      // a view change asks the API for nothing
      return;
    }

    // View toggles, not filters: re-render what we already hold rather than asking the
    // API for the same 24 products again.
    if (more) { state.allCats = !state.allCats; if (lastData) render(lastData); return; }
    if (fmore) {
      var k = fmore.dataset.saMore;
      if (k) { state[k] = !state[k]; if (lastData) render(lastData); }
      return;
    }

    // 2026-08-21 (owner): the By-vehicle door LINKS to /pages/manufacturers (its href) instead
    // of opening the in-place picker — the manufacturers hub is the built vehicle experience now.
    if (door) return;

    if (!f && !un && !cat && !cl) return;
    e.preventDefault();
    if (f) {
      state[f.dataset.f] = state[f.dataset.f] === f.dataset.v ? '' : f.dataset.v;
      // OPTIMISTIC: reflect the checkbox the instant it is clicked so the filter feels responsive even
      // while the (sometimes cold, multi-second) catalog fetch is in flight; render() rebuilds the full
      // facet list with fresh counts when it returns.
      var _on = state[f.dataset.f] === f.dataset.v;
      f.setAttribute('aria-pressed', _on ? 'true' : 'false');
      var _box = f.querySelector('.cpg-facet__box');
      if (_box) _box.innerHTML = _on ? ico('check', 'ico--s') : '';
    }
    // The vehicle chip removes the FILTER, not the saved vehicle. Clearing someone's
    // garage because they wanted to see the whole catalogue once would be theft.
    if (un) { if (un.dataset.un === 'fit') state.noFit = true; else state[un.dataset.un] = ''; }
    if (cat) state.main = cat.dataset.cat;
    if (cl) { state.main = state.vendors = state.stock = state.price = ''; state.noFit = true; }
    // EVERY FILTER CHANGE GOES BACK TO PAGE 1. Narrowing from page 40 of an unfiltered
    // catalogue to a result set with 3 pages would ask the API for page 40 of 3 and render
    // an empty grid that looks exactly like "no matches".
    state.page = 1;
    load();
  });

  /* Per-panel type-ahead. Re-renders from data already held — no request — and keeps focus
     and the caret, because innerHTML on the rail destroys the very input being typed into.
     Without the restore, the field lost focus after the first keystroke and the panel
     could only ever be searched one letter at a time. */
  root.addEventListener('input', function (e) {
    var box = e.target.closest('[data-sa-facetsearch]');
    if (!box) return;
    var key = box.dataset.saFacetsearch;
    if (!key) return;
    state.facetQ[key] = box.value;
    var at = box.selectionStart;
    if (lastData) render(lastData);
    var again = root.querySelector('[data-sa-facetsearch="' + key + '"]');
    if (again) { again.focus(); try { again.setSelectionRange(at, at); } catch (err) {} }
  });

  /* The primary door. If the site's picker is on the page, open it in place; otherwise
     let the link do its job. It is an <a> with a real href precisely so that it still
     works when the picker is not there — which was the whole problem with href="#". */
  function openPicker(e) {
    if (window.CPGFitment && typeof window.CPGFitment.openPicker === 'function') {
      e.preventDefault();
      window.CPGFitment.openPicker();
    }
  }

  /* ── THE RAIL'S VEHICLE PICKER ─────────────────────────────────────────────────────
     Year, then make, then model, because that is what the fitment endpoints require:
     /makes needs a year and /models needs a year and a make. Each step is disabled until
     the one above it is answered, so the cascade cannot be asked a question it has no
     answer for.

     Choosing here writes the garage and fires cpg:vehicle-changed, which is what the rest
     of the site listens to. This is not a private picker for one page — it sets the same
     vehicle the header bar and the product pages read. */
  var vmY = q('[data-vm-year]'), vmMk = q('[data-vm-make]'), vmMd = q('[data-vm-model]'),
      vmSm = q('[data-vm-submodel]'), vmGo = q('[data-vm-go]');

  function fillSelect(sel, values, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + '</option>' +
      values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('');
    sel.disabled = values.length === 0;
  }
  function resetBelow(which) {
    if (which <= 1) { fillSelect(vmMk, [], 'Make'); vmMk.disabled = true; }
    if (which <= 2) { fillSelect(vmMd, [], 'Model'); vmMd.disabled = true; }
    if (vmSm) { fillSelect(vmSm, [], 'Submodel'); vmSm.disabled = true; }
    vmGo.disabled = !(vmY.value && vmMk.value && vmMd.value);
  }
  function cascade(url, sel, placeholder, key) {
    sel.disabled = true;
    fetch(API + url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (d) {
        var list = d[key] || [];
        fillSelect(sel, list, placeholder);
      })
      .catch(function () {
        // A dead step must not look like an empty catalogue. Leave it disabled and say so.
        sel.innerHTML = '<option value="">' + placeholder + ' unavailable</option>';
      });
  }

  if (vmY && vmMk && vmMd && vmGo) {
    cascade('/storefront/fitment/years', vmY, 'Year', 'years');
    vmY.addEventListener('change', function () {
      resetBelow(1);
      if (!vmY.value) return;
      cascade('/storefront/fitment/makes?year=' + encodeURIComponent(vmY.value), vmMk, 'Make', 'makes');
    });
    vmMk.addEventListener('change', function () {
      resetBelow(2);
      if (!vmMk.value) return;
      cascade('/storefront/fitment/models?year=' + encodeURIComponent(vmY.value) +
              '&make=' + encodeURIComponent(vmMk.value), vmMd, 'Model', 'models');
    });
    vmMd.addEventListener('change', function () {
      if (vmSm) { fillSelect(vmSm, [], 'Submodel'); vmSm.disabled = true; }
      vmGo.disabled = !(vmY.value && vmMk.value && vmMd.value);
      // Submodel is OPTIONAL (mirrors the collection page finder): cascade fills it if the vehicle has
      // submodels — fillSelect leaves it disabled when the list is empty — and it never gates Find Parts.
      if (vmMd.value && vmSm) cascade('/storefront/fitment/submodels?year=' + encodeURIComponent(vmY.value) +
              '&make=' + encodeURIComponent(vmMk.value) + '&model=' + encodeURIComponent(vmMd.value), vmSm, 'Submodel', 'submodels');
    });
    if (vmSm) vmSm.addEventListener('change', function () { /* optional — does not change the button state */ });
    vmGo.addEventListener('click', function () {
      if (!(vmY.value && vmMk.value && vmMd.value)) return;
      var v = { year: parseInt(vmY.value, 10) || null, make: vmMk.value, model: vmMd.value, submodel: (vmSm && vmSm.value) || null };
      try { localStorage.setItem(KEY, JSON.stringify(v)); lastGarage = localStorage.getItem(KEY); }
      catch (e) { /* private mode: the page still filters, the choice just does not persist */ }
      // Tell the rest of the site. The header bar, the tabbar's garage and the product
      // pages all listen for this; without it they would still say "no vehicle" while this
      // page showed a filtered catalogue.
      try {
        window.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: v }));
        document.dispatchEvent(new CustomEvent('cpg:vehicle-changed', { detail: v }));
      } catch (e) {}
      // URL_VEH would otherwise outrank the choice just made.
      URL_VEH = null;
      state.noFit = false;
      load();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  var sort = q('[data-sort]');
  if (sort) sort.addEventListener('change', function (ev) {
    state.sort = ev.target.value; state.page = 1; load();
  });
  var perPage = q('[data-perpage]');
  if (perPage) perPage.addEventListener('change', function (ev) {
    // Page 40 at 24 a page is page 10 at 96. Rather than guess what the reader meant,
    // go back to the start of the same result set.
    state.pageSize = parseInt(ev.target.value, 10) || 12;
    state.page = 1;
    load();
  });

  // ── mobile Filter & Sort SHEET (phones) — ported from cpg-collection.js ───────────────
  // A full-screen overlay. On open we MOVE the live .cpg-rail node into the sheet body so there
  // is exactly one [data-facets] (with the desktop rail's handlers); on close we put it back.
  // Sort / Per-page render as tappable BUTTONS built from the real <select> options — this is the
  // fix: the old dock "Sort" clicked a display:none <select> in the toolbar, which a phone cannot
  // open, so mobile sort did nothing. Filters apply live as you tap; "Show N results" just closes.
  var sheet = q('[data-sheet]');
  var railHome = null;
  function buildSheetControls() {
    var sw = q('[data-sheet-sorts]');
    if (sort && sw) sw.innerHTML = Array.prototype.map.call(sort.options, function (o) {
      return '<button type="button" class="cpg-ssort" data-ssort="' + esc(o.value) + '"><span>' +
        esc(o.textContent.replace(/^\s*Sort:\s*/i, '')) + '</span><span class="rd"></span></button>';
    }).join('');
    var pp = q('[data-perpage]'), pw = q('[data-sheet-pp]');
    if (pp && pw) pw.innerHTML = Array.prototype.map.call(pp.options, function (o) {
      return '<button type="button" class="cpg-spp" data-spp="' + esc(o.value) + '">' + esc(o.value) + '</button>';
    }).join('');
  }
  function syncSheet() {
    if (!sheet) return;
    root.querySelectorAll('[data-ssort]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-ssort') === state.sort); });
    root.querySelectorAll('[data-spp]').forEach(function (b) {
      b.classList.toggle('is-on', parseInt(b.getAttribute('data-spp'), 10) === state.pageSize); });
    var c = q('[data-sheet-count]'); if (c && lastData) c.textContent = fmt(lastData.total);
  }
  function openSheet(where) {
    if (!sheet) return;
    var rail = q('.cpg-rail'), body = q('[data-sheet-body]');
    if (rail && body && rail.parentNode !== body) { railHome = { parent: rail.parentNode, next: rail.nextSibling }; body.appendChild(rail); }
    sheet.hidden = false; sheet.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    syncSheet();
    var scroll = q('[data-sheet-scroll]'), bodyEl = q('[data-sheet-body]');
    if (scroll) scroll.scrollTop = (where === 'filters' && bodyEl) ? Math.max(0, bodyEl.offsetTop - 56) : 0;
  }
  function closeSheet() {
    if (!sheet) return;
    var rail = q('.cpg-rail');
    if (rail && railHome && railHome.parent) { railHome.parent.insertBefore(rail, railHome.next); railHome = null; }
    sheet.hidden = true; sheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (sheet) {
    buildSheetControls();
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-sheet-close]')) { e.preventDefault(); closeSheet(); return; }
      var ss = e.target.closest('[data-ssort]');
      if (ss) { e.preventDefault(); state.sort = ss.getAttribute('data-ssort'); state.page = 1;
        if (sort) sort.value = state.sort; syncSheet(); load(); return; }
      var sp = e.target.closest('[data-spp]');
      if (sp) { e.preventDefault(); state.pageSize = parseInt(sp.getAttribute('data-spp'), 10) || 12; state.page = 1;
        var pp = q('[data-perpage]'); if (pp) pp.value = String(state.pageSize); syncSheet(); load(); return; }
      if (e.target.closest('[data-sheet-clear]')) {
        e.preventDefault();
        state.main = state.vendors = state.stock = state.price = ''; state.noFit = true;
        state.page = 1; load();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    // A phone rotated to a wide viewport: put the rail back and drop the overlay so the desktop
    // layout isn't left with the facet rail trapped inside a hidden sheet.
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) { var rail = q('.cpg-rail'), body = q('[data-sheet-body]'); if (rail && body && rail.parentNode === body) closeSheet(); }
    });
  }
  // Dock + toolbar: Filters and Sort both open the sheet (Filters jumps to the facet body, Sort
  // opens at the top where the sort buttons live). Top stays a scroll-to-top.
  var dockF = q('[data-sa-dock-filters]'); if (dockF) dockF.onclick = function () { openSheet('filters'); };
  var barF  = q('[data-sa-toolbar-filters]'); if (barF) barF.onclick = function () { openSheet('filters'); };
  var dockS = q('[data-sa-dock-sort]'); if (dockS) dockS.onclick = function () { openSheet('sort'); };
  var dockT = q('[data-sa-dock-top]'); if (dockT) dockT.onclick = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };

  /* The garage can change while this page is open: the header bar, another tab, the save
     card on a vehicle page. Compare the raw string — cpg:vehicle-changed also fires as an
     echo on bfcache restore and timers, and reloading on every echo is a request storm. */
  /* THE DOCK HAS TO SIT ON TOP OF THE SITE'S OWN BOTTOM BAR, NOT UNDER IT.
     The theme pins nav.cpg-tabbar (Shop / Garage / Cart) to bottom:0 at z-index 1350. Our
     dock is also bottom:0 at z-index 40, so it was rendering completely behind it and the
     Filters button — the only route to the facet rail on a phone — could not be reached.
     Measured at runtime rather than hard-coded: the tabbar is a theme component and its
     height is not ours to assume. */
  /* THE THEME OWNS THE BOTTOM OF THE SCREEN, SO THE DOCK GIVES IT UP.
     First attempt was to lift our dock clear of nav.cpg-tabbar. It worked, and it was
     still wrong: two full-width bars stacked on top of each other, 141px of a 900px
     screen spent on chrome, with the Live Chat bubble landing on the third button. Three
     bars competing at the bottom of a phone is not a layout, it is a pile.

     So the same rule as the vehicle bar: where the theme already owns that furniture, we
     stand down. Filters moves up into the results toolbar, which is sticky, always
     visible, and sits next to the sort control it belongs with. The dock stays for the
     case with no site tabbar — the local harness, and any theme that has none. */
  /* ONE BAR AT THE BOTTOM, AND IT IS THIS ONE.

     Owner call: the red Filters / Sort / Top dock is the bottom bar here. Two full-width
     bars stacked cost 141px of a 900px screen, with the chat bubble landing on the third
     button. Hiding ours instead was tried and lost the only route to the facet rail on a
     phone, so the site bar is the one that gives way.

     THE SECTION NO LONGER DOES THAT ITSELF. An earlier pass stamped a class on <html> and
     hid nav.cpg-tabbar from this stylesheet — a page-scoped patch for a site-wide
     decision. The bar is now gated to the homepage in snippets/cpg-tabbar.liquid, so on
     this page it does not render and there is nothing to hide. This function's remaining
     job is simply to reserve the dock's own height. */
  function fitDock() {
    var dock = q('.cpg-dock'); if (!dock) return;
    dock.hidden = false;
    root.style.setProperty('--cpg-dock-bottom', '0px');
    root.style.setProperty('--cpg-dock-h', '84px');
    // The toolbar's Filters button was the alternative home for this control. With the
    // dock present it would be the same control twice, 600px apart.
    var tf = q('[data-sa-toolbar-filters]');
    if (tf) tf.hidden = true;
    root.classList.remove('cpg-sa2--toolbar-controls');
  }
  /* (B) fitDock reserves the dock height with FIXED values (the site tabbar is gated off this page,
     so there is nothing to measure). One call before paint + a resize listener is enough — the old
     load-event re-run and the 1.2s/3s re-measures were redundant main-thread work (2026-08-18). */
  fitDock();
  window.addEventListener('resize', fitDock);

  /* (C) Kick the data fetch off NOW, before the cheap garage-listener wiring below, so the network
     request is already in flight while that setup runs (it used to be the very last statement). */
  load();

  var lastGarage = null;
  try { lastGarage = localStorage.getItem(KEY); } catch (e) {}
  function onGarageChange() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) {}
    // When a URL vehicle is active, veh() returns it over the garage, so a garage Remove would
    // otherwise leave the page filtered. Always process while URL_VEH is set (and clear it), so
    // the garage becomes authoritative the moment the shopper changes or removes a vehicle.
    if (raw === lastGarage && !URL_VEH) return;
    lastGarage = raw;
    URL_VEH = null;
    state.noFit = false;
    load();
  }
  window.addEventListener('cpg:vehicle-changed', onGarageChange);
  document.addEventListener('cpg:vehicle-changed', onGarageChange);
  window.addEventListener('storage', function (e) { if (!e.key || e.key === KEY) onGarageChange(); });
  // Back/forward (bfcache) restore: the script does NOT re-run, so a vehicle added on another
  // page while this one was cached would leave the whole page (grid, door, counts) stale. Re-sync.
  window.addEventListener('pageshow', function (e) { if (e.persisted) onGarageChange(); });
})();
